export const API_URL = process.env.REACT_APP_API_URL as string;
export const API_URL_MAIN = process.env.REACT_APP_API_URL_MAIN as string;
export const FE_URL = process.env.REACT_APP_FE_URL as string;
export const FE_LOGIN_URL = process.env.REACT_APP_FE_LOGIN_URL as string;
export const FE_LOGOUT_URL = process.env.REACT_APP_FE_LOGOUT_URL as string;
export const FE_LOGIN_CLIENT_ID = process.env.REACT_APP_FE_LOGIN_CLIENT_ID as string;
export const FE_LOGIN_GRANT_TYPE = process.env.REACT_APP_FE_LOGIN_GRANT_TYPE as string;
export const FE_LOGOUT_URL_AZURE = process.env.REACT_APP_FE_LOGOUT_URL_AZURE as string;
export const FE_USER_INFO = process.env.REACT_APP_FE_USER_INFO as string;
export const ENVIRONMENT_TYPE = process.env.REACT_APP_ENVIRONMENT_TYPE as string;
